/** @jsxImportSource @emotion/react */
import { Badge } from "reactstrap";
import { LAYER_STAGE } from "../../../../actions/Layers/constants";
import { CategoryType, Stage } from "../../../../actions/Tenants/config/constantsTyped";
import Field, { DataSource } from "./Field";

/*
    This field renders a badge for each stage of a layer.
*/
class LayerStagesColorBadgeField extends Field {
    field_type = "layer_stages_color_badge_field";

    badges: Array<{ value: string; status_letter: string; status_color: string; text?: string }> = [];

    backend_table = "layer_meta";

    // * Optional tenant stages config injected via setupFieldClassFromConfig.
    // * When present, drives which {value}_status fields are requested from the backend.
    // * Falls back to the hardcoded LAYER_STAGE enum for backward compatibility.
    stages_config?: Stage[];

    get_category_badges(): Array<{ value: string; status_letter: string; text?: string }> {
        const categories = Array.isArray(this.field_config?.categories) ? this.field_config.categories as CategoryType[] : [];
        return categories
            .filter((i) => typeof i.value === "string" && i.value && i.label)
            .map((i) => ({ value: i.value as string, status_letter: i.label, text: i.label }));
    }

    get_stage_badges(stages: Stage[]): Array<{ value: string; status_letter: string; text?: string }> {
        return stages
            .filter((i: Stage) => i.layer_type && !i.hide_color_code)
            .map((i) => ({ value: `${i.value}_status`, status_letter: i.status_letter || "", text: i.text }));
    }

    get_backend_fieldname(): string[] {
        const categoryBadges = this.get_category_badges();
        if (categoryBadges.length) {
            const unique = Array.from(new Set(categoryBadges.map((i) => i.value)));
            return unique.map((i) => `${this.backend_table}.${i}`);
        }

        const stageValues: string[] = this.stages_config && this.stages_config.length
            ? this.stages_config.filter((i: Stage) => i.layer_type && !i.hide_color_code).map((i: Stage) => i.value)
            : Object.keys(LAYER_STAGE).map((i) => i.toLowerCase());
        const unique = Array.from(new Set(stageValues));
        return unique.map((i) => `${this.backend_table}.${i}_status`);
    }


    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        const { stages } = datasource.config;
        const categoryBadges = this.get_category_badges();
        const fallbackStages = this.stages_config && this.stages_config.length ? this.stages_config : stages;
        const badges = categoryBadges.length ? categoryBadges : this.get_stage_badges(fallbackStages);

        this.badges = badges.map((i) => ({
            ...i,
            status_color: datasource.layer?.[i.value] || "secondary",
        }));
        this.value = this.badges.map((i) => `${i.text || i.value}: ${i.status_color}`).join(", ");
        return this;
    }

    display_component(): JSX.Element {
        return <span>{this.badges.map((i) => <Badge key={i.value} size="sm" className="me-1" color={i.status_color}>{i.status_letter}</Badge >)}</span>;
    }

}

export default LayerStagesColorBadgeField;


